import React, { useState, useRef } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import CustomEditor from '@ckeditor/ckeditor5-build-classic-custom-pih';
import PropTypes from 'prop-types';

// Need to make changes to CKEditor that require rebuild?
// Do them in https://git.crasmanhosting.fi/nokiantyres/pih/ckeditor-custom-build

import {
  Grid,
  FormHelperText,
  TextField,
  makeStyles
} from '@material-ui/core';

import Tooltip from '../tooltip';

function MyInputComponent(props) {
  const { component: Component, inputRef, ...other } = props;

  // implement `InputElement` interface
  React.useImperativeHandle(inputRef, () => ({
    focus: () => {
      // logic to focus the rendered component from 3rd party belongs here
    },
    // hiding the value e.g. react-stripe-elements
  }));

  // `Component` will be your `SomeThirdPartyComponent` from below
  return <Component {...other} />;
}

MyInputComponent.propTypes = {
  component: PropTypes.any,
  inputRef: PropTypes.func
};

function MyEditorComponent(props) {
  const {value, disabled, handleChange, setCount, hasMaxLength, name, handleFocus, handleBlur} = props;

  return (
    <CKEditor
      editor={CustomEditor}
      config={{
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
          ]
        }
      }}
      data={value}
      disabled={disabled}
      onChange={(event, editor) => {
        const data = editor.getData();
        handleChange({target: {name, value: data}});
      }}
      onReady={editor => {
        if(!editor) {
          // Editor can be null if unmounting before it is done initialising.
          return;
        }
        if(hasMaxLength) {
          setCount(editor.plugins.get('WordCount').characters);

          editor.plugins.get('WordCount').on('update', (evt, stats) => {
            setCount(stats.characters);
            //Does not limit writing..
          });
        }
      }}
      onFocus={editor => {
        handleFocus();
      }}
      onBlur={editor => {
        handleBlur();
      }}
    />
  )
}

MyEditorComponent.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  setCount: PropTypes.func,
  hasMaxLength: PropTypes.bool,
  name: PropTypes.string,
  handleFocus: PropTypes.func,
  handleBlur: PropTypes.func
}


const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiInputBase-root': {
      display: 'block',
      padding: '18.5px 14px'
    },
    '& .ck-editor__editable': {
      minHeight: '200px'
    }
  }
}));

const Editor2 = (props) => {

  const {
    onChange,
    name,
    value,
    label,
    disabled,
    helperText,
    maxLength,
    tooltip,
    ...rest
  } = props;

  const classes = useStyles();
  const fieldRef = useRef(null);

  const [ count, setCount ] = useState(0);
  const [ tooltipOpen, setTooltipOpen ] = useState(false);

  const hasMaxLength = typeof maxLength === 'number' && maxLength > 0;
  const hasHelperText = typeof helperText === 'string' && helperText.length > 0;
  let hasTooltip = !!tooltip;

  const handleFocus = event => {
    if(hasTooltip) {
      setTooltipOpen(true);
    }
  }

  const handleBlur = event => {
    if(hasTooltip) {
      setTooltipOpen(false);
    }
  }

  return (
    <>
      <TextField
        variant="outlined"
        fullWidth
        disabled={disabled}
        label={label}
        className={classes.root}
        ref={fieldRef}
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          inputComponent: MyInputComponent,
          inputProps: {
            component: MyEditorComponent,
            value,
            disabled,
            handleChange: onChange,
            setCount,
            hasMaxLength,
            name,
            handleFocus,
            handleBlur
          },
        }}
      />

      {(hasHelperText || hasMaxLength)
        ?
        <FormHelperText variant="outlined" component="div" error={rest.error}>
          <Grid container justifyContent="space-between">
            <Grid item style={{marginRight: '5px'}}>{helperText || ''}</Grid>
            <Grid item>{hasMaxLength ? `${count}/${maxLength}` : ''}</Grid>
          </Grid>
        </FormHelperText>
        : null
      }
      {hasTooltip
        ?
        <Tooltip
          open={tooltipOpen}
          anchorElRef={fieldRef}
          content={tooltip}
          arrow
        >
          {tooltip}
        </Tooltip>
        : null
      }
    </>
  )
};

Editor2.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  maxLength: PropTypes.number,
  tooltip: PropTypes.any
}

export default Editor2;
